






















import Vue from 'vue'
import filesize from 'filesize'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import OmnisearchResultSet from '@/modules/omnisearch/store/OmnisearchResultSet';
import OmnisearchResultItem from '@/modules/omnisearch/store/OmnisearchResultItem';


@Component
export default class MediaObjectsResultList extends Vue {
    @Prop({type: OmnisearchResultSet, default: () => new OmnisearchResultSet()})
    public set: OmnisearchResultSet


    public icon (type: string) {
        switch (true) {
            case type.startsWith('image'):
                return 'mdi-image-outline'
            case type === 'application/pdf':
                return 'mdi-file-pdf-outline'
            case type.startsWith('video'):
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }


    public typeName (type: string) {
        switch (true) {
            case type.startsWith('image'):
                return 'Imagen'
            case type === 'application/pdf':
                return 'Archivo PDF'
            case type.startsWith('video'):
                return 'Video'
            default:
                return 'Archivo'
        }
    }

    public formattedSize (bytes: number) {
        if (!bytes) {
            return 0
        }

        return filesize(bytes, {exponent: 2})
    }

    public select (item: OmnisearchResultItem) {
        this.$emit('select', item)
    }
}
